import Vue from 'vue'
import  Buefy  from  'buefy'
import  'buefy/dist/buefy.css'
import App from './App.vue'
import router from './router'
import store from './store'
import Firebase from "./firebase"
import titleMixin from './util/title'
import './util/registerServiceWorker'

Firebase.init()
Firebase.onAuth()

Vue.use(Buefy, {defaultIconPack: 'fa'})
Vue.config.productionTip = false
Vue.mixin(titleMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
